<template>
  <div class="main mainTest1">
      <div class="testT-section">
          <div class="example-img">
            <img src="../../assets/imageTests/posture_equilibre_0.png" alt="image test 1" class="img-test1 img-test12" width="190px">
          </div>

          <div class="bloc2">
            <div class="explication1">
              <p>Tenez vous debout en équilibre sur une jambe le plus longtemps possible.</p>
              <ul>
                <li>Garder les yeux ouverts</li>
                <li>Garder les bras le long du corps</li>
                <li>Choisir la jambe ou vous êtes le plus à l'aise</li>
              </ul>
              <p>Quand vous êtes prêt déclencher le chronomètre</p> 
            </div>
            <div class="timer-responsive">
              <div class="horloge"><BaseTimer timeLimit= 60 @stopClic="onStop()"/></div>
          </div>
        </div>
        </div>

        <div class="testT-section-portable">
          <div class="example-img-portable">
            <img src="../../assets/imageTests/posture_equilibre_0.png" alt="image test 1" class="img-test1 img-test12" width="190px">
          </div>

          <div class="bloc2-portable">
            <div class="explication1 explication1-portable">
              <p>Tenez vous debout en équilibre sur une jambe le plus longtemps possible.</p>
              <ul>
                <li>Garder les yeux ouverts</li>
                <li>Garder les bras le long du corps</li>
                <li>Choisir la jambe ou vous êtes le plus à l'aise</li>
              </ul>
              <p>Quand vous êtes prêt appuyé sur "Démarrer", puis sur "Arrêter une fois que vous avez reposé la jambe, vous pourrez refaire 1 essai en appuyant sur "Redémarrer".</p> 
            </div>
            
          </div>
          
        </div>
        <div class="timer-portable">
              <div class="horloge"><BaseTimer timeLimit= 60 @stopClic="onStop()"  @clickOnStart="onReStart()" /></div>
          </div>

    </div>
      
  
</template>

<script>

import BaseTimer from '@/components/BaseTimer';
export default {
  name: "Test_1",
  components: { BaseTimer },
  data() {
    return {
        timeStop: BaseTimer.data,
        timeMax: 15,
        result: '',
    };
  },
  
  methods: {
    onStop() {
      this.timeStop = document.getElementById('timer__label').innerHTML;
      this.$emit('stopClic');
    },
    onReStart(){
      this.$emit('startClic');
    }
  },
};
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/Test/Test_1.vue